export function excludeParams(
  searchParams: URLSearchParams,
  excludeKeys: string[]
): URLSearchParams {
  const newParams = new URLSearchParams();
  for (const [key, value] of searchParams.entries()) {
    if (!excludeKeys.includes(key)) {
      newParams.set(key, value);
    }
  }
  return newParams;
}

// Adds the current search params to a route path; the route's own params win
export function withMergedParams(
  path: string,
  searchParams: URLSearchParams
): string {
  const [pathname, routeQuery] = path.split('?');
  const mergedParams = new URLSearchParams(searchParams);
  new URLSearchParams(routeQuery).forEach((value, key) =>
    mergedParams.set(key, value)
  );
  const query = mergedParams.toString();
  return query ? `${pathname}?${query}` : pathname;
}
